export const PARTOGRAPH = {
  masterTableName: "MC_PARTOGRAPH",
  tableName: "MC_PARTOGRAPH_DET",
  traceTableName: "MC_PARTOGRAPH_TRACE",
  columnName: "MP_ID",
  columnValue: 0,
  title: "partograf-form.title",
  rows: [
    { title: "id", value: "ID", headerName: "ID" },
    { title: "date", value: "PROCESS_TIME", headerName: "Tarih" },
    { title: "FIRST_TOUCH", value: "FIRST_TOUCH", headerName: "partograf-form.first-touch" },
    { title: "PAIN_START_TIME", value: "PAIN_START_TIME", headerName: "partograf-form.pain-start-time", type: "date" },
    { title: "BIRTH_TIME", value: "BIRTH_TIME", headerName: "partograf-form.birth-time", type: "date" },
    { title: "PLACENTA_EXIT_TIME", value: "PLACENTA_EXIT_TIME", headerName: "partograf-form.placenta-exit-time", type: "date" },
    { title: "PREZENTATION", value: "PREZENTATION", headerName: "partograf-form.prezentation" },
    { title: "IS_SCA_INDICATION", value: "IS_SCA_INDICATION", headerName: "partograf-form.is-sca-indication" },
    { title: "IS_PLACENTA", value: "IS_PLACENTA", headerName: "partograf-form.is-placenta" },
    { title: "BABY_GENDER", value: "BABY_GENDER", headerName: "partograf-form.baby-gender" },
    { title: "BABY_WEIGHT", value: "BABY_WEIGHT", headerName: "partograf-form.baby-weight" },
    { title: "BABY_HEIGHT", value: "BABY_HEIGHT", headerName: "partograf-form.baby-height" },
    { title: "BABY_HEAD_CIRCUMFERENCE", value: "BABY_HEAD_CIRCUMFERENCE", headerName: "partograf-form.baby-head-circumference" },
    { title: "NOTE", value: "NOTE", headerName: "partograf-form.note" },
  ],
  fields: [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "FIRST_TOUCH", headerName: "partograf-form.first-touch", flex: 1 },
    { field: "PAIN_START_TIME", headerName: "partograf-form.pain-start-time", flex: 1, type: "date" },
    { field: "BIRTH_TIME", headerName: "partograf-form.birth-time", flex: 1, type: "date" },
    { field: "PLACENTA_EXIT_TIME", headerName: "partograf-form.placenta-exit-time", flex: 1, type: "date" },
    { field: "PREZENTATION", headerName: "partograf-form.prezentation", flex: 1 },
    { field: "IS_SCA_INDICATION", headerName: "partograf-form.is-sca-indication", flex: 1 },
    { field: "IS_PLACENTA", headerName: "partograf-form.is-placenta", flex: 1 },
    { field: "BABY_GENDER", headerName: "partograf-form.baby-gender", flex: 1 },
    { field: "BABY_WEIGHT", headerName: "partograf-form.baby-weight", flex: 1 },
    { field: "BABY_HEIGHT", headerName: "partograf-form.baby-height", flex: 1 },
    { field: "BABY_HEAD_CIRCUMFERENCE", headerName: "partograf-form.baby-head-circumference", flex: 1 },
    { field: "NOTE", headerName: "partograf-form.note", flex: 1 },
  ],
  mcpConfig: {
    PREZENTATION: { mcpId: 462, field: "PREZENTATION", scoreField: "PREZENTATION" },
    BABY_GENDER: { mcpId: 0, field: "BABY_GENDER", scoreField: "BABY_GENDER" }, // ImageComboBox için özel
    AMNION_FLUID: { mcpId: 460, field: "AMNION_FLUID", scoreField: "AMNION_FLUID" },
    PAIN_LEVEL: { mcpId: 461, field: "PAIN_LEVEL", scoreField: "PAIN_LEVEL" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    MP_ID: "",
    ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    NURSE_ID: "",
    FIRST_TOUCH: "",
    PAIN_START_TIME: null as Date | null,
    BIRTH_TIME: null as Date | null,
    PLACENTA_EXIT_TIME: null as Date | null,
    PREZENTATION: "",
    IS_SCA_INDICATION: "",
    IS_PLACENTA: "",
    BABY_GENDER: "",
    BABY_WEIGHT: "",
    BABY_HEIGHT: "",
    BABY_HEAD_CIRCUMFERENCE: "",
    NOTE: "",
  },
};
